import BackgroundElementMetaData from './BackgroundElementMetaData';

const presets = [
  {
    type: BackgroundElementMetaData.type,
    id: BackgroundElementMetaData.id,
    layout: {
      x: 0,
      y: 0,
      width: '100%',
      height: '100%'
    },
    compProps: {
      backgroundColor: '#fff',
      backgroundImage: {},
      zIndex: -1100
    },
    hidden: false
  }
];

export default presets;
